<div class="row">
  <div class="col-12">
    <div id="errorAlertWindow" *ngIf="errorAlertWindowOpened" [@openErrorAlert]>
      <div id="termsOfUseErrorMessage" *ngIf="termsOfUseErrorMessageShown"
           class="alert alert-danger mb-4 py-4" role="alert">
        <p>We encountered an issue completing your request. Terms of use are not loaded.
        </p>
        <span>If you believe you have received this message by mistake, please contact Customer
          Service at {{ customerServicePhone }}.</span>
      </div>

      <div id="memberAlreadyRegisteredMessage" *ngIf="memberAlreadyRegisteredMessageShown"
           class="alert alert-danger mb-4 py-4" role="alert">
        <p>We noticed you have already registered for My Benefits.
          Please select <a [routerLink]="'/trouble-signing-in'"><u>Trouble Signing In</u></a>.
        </p>
        <span>If you believe you have received this message by mistake, please contact Customer
          Service at {{ customerServicePhone }}.</span>
      </div>

      <div id="ssnForbiddenSymbolsMessage" *ngIf="ssnForbiddenSymbolsMessageShown"
           class="alert alert-danger mb-4 py-4" role="alert">
        <p>We encountered an issue completing your request.</p>
        <p>Social Security Number must only contain digits.</p>
      </div>

      <div id="ssnRequiredLengthMessage" *ngIf="ssnRequiredLengthMessageShown"
           class="alert alert-danger mb-4 py-4" role="alert">
        <p>We encountered an issue completing your request.</p>
        <p>Social Security Number must contain exactly 9 digits.</p>
      </div>

      <div id="ssnRequiredMessage" *ngIf="ssnRequiredMessageShown"
           class="alert alert-danger mb-4 py-4" role="alert">
        <p>We encountered an issue completing your request.</p>
        <p>Social Security Number is required.</p>
      </div>

      <div id="surnameRequiredMessage" *ngIf="surnameRequiredMessageShown"
           class="alert alert-danger mb-4 py-4" role="alert">
        <p>We encountered an issue completing your request.</p>
        <p>Last Name is required.</p>
      </div>

      <div id="surnameMaxLengthMessage" *ngIf="surnameMaxLengthMessageShown"
           class="alert alert-danger mb-4 py-4" role="alert">
        <p>We encountered an issue completing your request.</p>
        <p>Last Name must be less than 254 characters.</p>
      </div>

      <div id="surnameCannotContainCharsMessage" *ngIf="surnameCannotContainCharsMessageShown"
           class="alert alert-danger mb-4 py-4" role="alert">
        <p>We encountered an issue completing your request.</p>
        <p>Last Name cannot contain special characters.</p>
      </div>

      <div id="givenNameRequiredMessage" *ngIf="givenNameRequiredMessageShown"
           class="alert alert-danger mb-4 py-4" role="alert">
        <p>We encountered an issue completing your request.</p>
        <p>First Name is required.</p>
      </div>

      <div id="givenNameMinLengthMessage" *ngIf="givenNameMinLengthMessageShown"
           class="alert alert-danger mb-4 py-4" role="alert">
        <p>We encountered an issue completing your request.</p>
        <p>First Name must have at least 1 character.</p>
      </div>

      <div id="givenNameMaxLengthMessage" *ngIf="givenNameMaxLengthMessageShown"
           class="alert alert-danger mb-4 py-4" role="alert">
        <p>We encountered an issue completing your request.</p>
        <p>First Name cannot be longer than 64 characters.</p>
      </div>

      <div id="givenNameNotTrimmedMessage" *ngIf="givenNameNotTrimmedMessageShown"
           class="alert alert-danger mb-4 py-4" role="alert">
        <p>We encountered an issue completing your request.</p>
        <p>First Name may not contain spaces before the first character, or after the last character.</p>
      </div>

      <div id="dobFormatMessage" *ngIf="dobFormatMessageShown"
           class="alert alert-danger mb-4 py-4" role="alert">
        <p>We encountered an issue completing your request.</p>
        <p>Date of Birth must be in the correct format (mm/dd/yyyy).</p>
      </div>

      <div id="phoneFormatMessage" *ngIf="phoneFormatMessageShown"
           class="alert alert-danger mb-4 py-4" role="alert">
        <p>We encountered an issue completing your request.</p>
        <p>Phone Number must be 10 digits OR in the correct format [(123) 456-7890].</p>
      </div>

      <div id="genericErrorMessage" *ngIf="genericErrorMessageShown" class="alert alert-danger mb-4 py-4" role="alert">
        <p>We encountered an issue completing your request.</p>
        <span>Please try again later or contact Customer Service at {{ customerServicePhone }}.</span>
      </div>

      <div id="passwordContainsNameErrorMessage" *ngIf="passwordContainsNameErrorMessageShown"
        class="alert alert-danger mb-4 py-4" role="alert">
        <p>We encountered an issue completing your request.</p>
        <p>Password cannot contain your Username, First Name, Last Name, or other Blacklisted terms. Please enter a new password, and try again.</p>
      </div>
    </div>

    <form id="registrationForm" [formGroup]="regForm" (ngSubmit)="submitRegistrationForm(child)">
      <div class="mb-4">
        <div class="form-group form-label-group">
          <input id="usernameInput" formControlName="usernameInput" class="form-control" placeholder="Username" maxlength="50" (keyup)="allowOnlyAlphaNumerics($event)" (keydown)="allowOnlyAlphaNumerics($event)"
                 [ngClass]="{ 'is-invalid': formControls.usernameInput.touched && formControls.usernameInput.errors }">
          <label for="usernameInput">Username</label>
          <div *ngIf="formControls.usernameInput.touched && formControls.usernameInput.errors" class="invalid-feedback">
            <div *ngIf="(this.submitted || formControls.usernameInput.touched) && formControls.usernameInput.errors.required">Username is required.</div>
            <div *ngIf="(this.submitted || formControls.usernameInput.touched) && formControls.usernameInput.errors.minlength">Username must be at least 7 symbols long.</div>
            <div *ngIf="(this.submitted || formControls.usernameInput.touched) && formControls.usernameInput.errors.maxlength">Username must not be longer than 100 symbols.</div>
            <div *ngIf="(this.submitted || formControls.usernameInput.touched) && !formControls.usernameInput.errors.minlength && !formControls.usernameInput.errors.maxlength &&
              formControls.usernameInput.errors.pattern">Username must contain only alphanumeric symbols.</div>
            <div *ngIf="(this.submitted || formControls.usernameInput.touched) && !formControls.usernameInput.errors.minlength && !formControls.usernameInput.errors.maxlength &&
              !formControls.usernameInput.errors.pattern && formControls.usernameInput.errors.uniqueUsername">
              Username is already in use. Please, choose another username.</div>
            <div *ngIf="(this.submitted || formControls.usernameInput.touched) && formControls.usernameInput.errors.unexpectedError">Unexpected server error occurred
              while validating username. Please contact Customer Service at {{ customerServicePhone }}.</div>
          </div>
        </div>
        <div class="form-group form-label-group">
          <input id="passwordInput" formControlName="passwordInput" type="password" class="form-control" placeholder="Password"
                 [ngClass]="{ 'is-invalid': formControls.passwordInput.touched && formControls.passwordInput.errors }">
          <label for="passwordInput">Password</label>
          <span class="password-help" data-toggle="password-modal">
            <small id="passwordHelp" class="form-text text-muted">Please enter and confirm your password. View our <a data-toggle="modal" href="#password-modal">Password Guidelines</a> for more details.</small>
          </span>

          <div id="password-modal" class="modal fade bd-example-modal-md" tabindex="-1" role="dialog">
		        <div class="modal-dialog modal-lg">
			        <div class="modal-content">
				        <div class="modal-header">
					        <h4 class="modal-title">Security Guidelines for a Safe Password</h4>
				        </div>
				        <div class="modal-body">
					        <ul>
                    <li>Don't include personal information (First name, Last name, Birth date, etc.)</li><br>
                    <li>Make sure your Username and Password are different</li><br>
                    <li>Change your password often</li><br>
                    <li>Make sure your new password isn't the same as your last 24 passwords</li><br>
                    <li>Never share your password with anyone</li><br>
                    <li>Never write your password down or email it to anyone</li><br>
                    <li>For security reasons, your password must include one of the following special characters: ~, !, @, #, $, %, ^, &, *, (, ), [, {{'{'}}, }</li><br>
                    <li class="secondary-list">For security reasons, your password may not use: <br> <br>
                      <p>- Abbreviated months or days of the week, like JAN, OCT, MON or TUE</p>
                      <p>- Repeating letters or numbers, like aaa111</p>
                      <p>- Letters or numbers in order, like abc123</p>
                      <p>- More than 5 numbers next to each other</p>
                      <p>- Special words, SYS, LOG, TSO, PAS, NEW, NET, ROS, XXX, SIGN, VTAM, DEMO, ASDF, 1234, BASIC, FOCUS, CADAM, VALID, GAME, IL1, TX1, OK1, NM1, MT1, DG1, MI1 and APPL</p>
                    </li>
                  </ul>
				        </div>
				        <div class="modal-footer">
					        <button class="btn btn-primary" data-dismiss="modal">Close</button>
				        </div>
			        </div>
		        </div>
	        </div>


          <div *ngIf="formControls.passwordInput.touched && formControls.passwordInput.errors" class="invalid-feedback">
            <div *ngIf="(this.submitted || formControls.passwordInput.touched) && formControls.passwordInput.errors.required">Password is required.</div>
            <div *ngIf="(this.submitted || formControls.passwordInput.touched) && formControls.passwordInput.errors.minlength">Password must be at least 8 symbols long.</div>
            <div *ngIf="(this.submitted || formControls.passwordInput.touched) && formControls.passwordInput.errors.maxlength">Password must not be longer than 40 symbols.</div>
            <div *ngIf="(this.submitted || formControls.passwordInput.touched) && !formControls.passwordInput.errors.minlength && !formControls.passwordInput.errors.maxlength &&
              formControls.passwordInput.errors.pattern">
              Password requirements:<br>
              <div *ngIf="(this.submitted || formControls.passwordInput.touched) && formControls.passwordInput.errors.atLeastOneLowerCaseCharacter">
                - at least 1 character in lower case is present;<br></div>
              <div *ngIf="(this.submitted || formControls.passwordInput.touched) && formControls.passwordInput.errors.atLeastOneUpperCaseCharacter">
                - at least 1 character in upper case is present;<br></div>
              <div *ngIf="(this.submitted || formControls.passwordInput.touched) && formControls.passwordInput.errors.atLeastOneDigit">
                - at least 1 digit is present;<br></div>
              <div *ngIf="(this.submitted || formControls.passwordInput.touched) && formControls.passwordInput.errors.atLeastOneSpecialCharacter">
                - at least 1 special character is present: ~, !, @, #, $, %, ^, &, *, (, ), [, {{'{'}}, }</div>
            </div>
            <div *ngIf="(this.submitted || formControls.passwordInput.touched) && !formControls.passwordInput.errors.minlength && !formControls.passwordInput.errors.maxlength &&
              !formControls.passwordInput.errors.pattern">
              <div *ngIf="formControls.passwordInput.errors.repeatingChars">
                Password must not contain more than 2 repeating characters in a row - e.g. aaa, bBb, 111, @@@.</div>
              <div *ngIf="!formControls.passwordInput.errors.repeatingChars &&
              formControls.passwordInput.errors.consecutiveChars">
              Password must not contain more than 2 consecutive characters in a row - e.g. aBc, CbA, 123 or 321.</div>
              <div *ngIf="!formControls.passwordInput.errors.repeatingChars &&
              !formControls.passwordInput.errors.consecutiveChars && formControls.passwordInput.errors.blacklistedPassword">
              Password must not contain any of the reserved words - e.g. SYS, LOG, TSO, etc. See Password Guidelines.</div>
              <div *ngIf="!formControls.passwordInput.errors.repeatingChars &&
              !formControls.passwordInput.errors.consecutiveChars && formControls.passwordInput.errors.containsMonth">
              Password must not contain a month abbreviation - e.g. Jan, Feb, Mar, etc.</div>
              <div *ngIf="!formControls.passwordInput.errors.repeatingChars &&
              !formControls.passwordInput.errors.consecutiveChars && formControls.passwordInput.errors.containsWeekDay">
              Password must not contain a weekday abbreviation - e.g. Mon, Tue, Wed, etc.</div>
              <div *ngIf="!formControls.passwordInput.errors.repeatingChars &&
              !formControls.passwordInput.errors.consecutiveChars && formControls.passwordInput.errors.containsChar">
              Password must not contain characters other than a-z, A-Z, 0-9, !@#$%^&*(){{'{'}}[~</div>
            </div>
          </div>
        </div>
        <div class="form-group form-label-group">
          <input id="confirmPasswordInput" formControlName="confirmPasswordInput" type="password" class="form-control"
                 placeholder="Confirm password"
                 [ngClass]="{ 'is-invalid': formControls.confirmPasswordInput.touched &&
                 (formControls.confirmPasswordInput.errors || regForm.errors?.passwordAreNotEqual) }">
          <label for="confirmPasswordInput">Confirm password</label>
          <div *ngIf="formControls.confirmPasswordInput.touched && (formControls.confirmPasswordInput.errors || regForm.errors?.passwordAreNotEqual)"
               class="invalid-feedback">
            <div *ngIf="(this.submitted || formControls.confirmPasswordInput.touched) && formControls.confirmPasswordInput.errors?.required">Please, confirm password.</div>
            <div *ngIf="(this.submitted || formControls.confirmPasswordInput.touched) && !formControls.confirmPasswordInput.errors?.required && regForm.errors?.passwordAreNotEqual">
              Confirm Password should match with the above field.</div>
          </div>
        </div>

        <hr/>

        <div class="form-group form-label-group">
          <input id="firstNameInput" formControlName="firstNameInput" class="form-control" placeholder="First Name" maxlength="64" (keyup)="allowOnlyLetters($event)" (keydown)="allowOnlyLetters($event)"
                 [ngClass]="{ 'is-invalid': formControls.firstNameInput.touched && formControls.firstNameInput.errors }">
          <label for="usernameInput">First Name</label>
          <div *ngIf="formControls.firstNameInput.touched && formControls.firstNameInput.errors" class="invalid-feedback">
            <div *ngIf="(this.submitted || formControls.firstNameInput.touched) && formControls.firstNameInput.errors.required">First Name is required.</div>
            <div *ngIf="(this.submitted || formControls.firstNameInput.touched) && formControls.firstNameInput.errors.minlength">First Name must be more than 1 character.</div>
            <div *ngIf="(this.submitted || formControls.firstNameInput.touched) && formControls.firstNameInput.errors.maxlength">First Name must be less than 64 characters.</div>
            <div *ngIf="(this.submitted || formControls.firstNameInput.touched) && formControls.firstNameInput.errors.pattern">First Name may only contain letters, spaces, hyphens and apostrophes.</div>

          </div>
        </div>
        <div class="form-group form-label-group">
          <input id="lastNameInput" formControlName="lastNameInput" class="form-control" placeholder="Last Name" maxlength="64" (keyup)="allowOnlyLetters($event)" (keydown)="allowOnlyLetters($event)"
                 [ngClass]="{ 'is-invalid': formControls.lastNameInput.touched && formControls.lastNameInput.errors }">
          <label for="lastNameInput">Last Name</label>
          <div *ngIf="formControls.lastNameInput.touched && formControls.lastNameInput.errors" class="invalid-feedback">
            <div *ngIf="(this.submitted || formControls.lastNameInput.touched) && formControls.lastNameInput.errors.required">Last Name is required.</div>
            <div *ngIf="(this.submitted || formControls.lastNameInput.touched) && formControls.lastNameInput.errors.minlength">Last Name must be more than 1 character.</div>
            <div *ngIf="(this.submitted || formControls.lastNameInput.touched) && formControls.lastNameInput.errors.maxlength">Last Name must be less than 64 characters.</div>
            <div *ngIf="(this.submitted || formControls.lastNameInput.touched) && formControls.lastNameInput.errors.pattern">Last Name may only contain letters, spaces, hyphens and apostrophes.</div>
          </div>
        </div>
        <div class="form-group form-label-group">
          <input id="ssnInput" formControlName="ssnInput" class="form-control" placeholder="Social Security Number"
                 [ngClass]="{ 'is-invalid': formControls.ssnInput.touched && formControls.ssnInput.errors }"
                 mask="000-00-0000" (blur)="maskSSNOnBlur($event.target)" (focus)="showSSNOnFocus($event.target)">
          <label for="ssnInput">Social Security Number</label>
          <div *ngIf="formControls.ssnInput.touched && formControls.ssnInput.errors" class="invalid-feedback">
            <div *ngIf="(this.submitted || formControls.ssnInput.touched) && formControls.ssnInput.errors.required">Social Security Number is required.</div>
            <div *ngIf="(this.submitted || formControls.ssnInput.touched) && formControls.ssnInput.errors.pattern">Only numeric values and hyphen allowed.</div>
            <div *ngIf="(this.submitted || formControls.ssnInput.touched) && !formControls.ssnInput.errors.required && !formControls.ssnInput.errors.pattern &&
              formControls.ssnInput.errors.invalidSsnLength">Should contain exactly 9 digits.</div>
          </div>
        </div>
        <div class="dob-input-group input-group form-label-group">
          <input id="dobInput" formControlName="dobInput" class="form-control" placeholder="Date of Birth"
                 [ngClass]="{'is-invalid': formControls.dobInput.touched && formControls.dobInput.errors,
                 'border-right-0': !formControls.dobInput.errors}"
                 ngbDatepicker #dob="ngbDatepicker" [minDate]="minDatepickerDate" [maxDate]="maxDatepickerDate"
                 maxlength="10" #dateOfBirth appDobMask>
          <label for="dobInput" style="z-index:100;">Date of Birth</label>

          <div class="input-group-append">
            <span class="input-group-text bg-transparent" (click)="dob.toggle()">
              <img class="align-text-top" src="assets/img/calendar.svg" alt="" width="16" height="16">
            </span>
          </div>
          <div *ngIf="formControls.dobInput.touched && formControls.dobInput.errors" class="invalid-feedback">
            <div *ngIf="(this.submitted || formControls.dobInput.touched) && formControls.dobInput.errors.required">Date of Birth is required.</div>
            <div *ngIf="(this.submitted || formControls.dobInput.touched) && formControls.dobInput.touched && formControls.dobInput.errors.futureDobValue">Date of Birth cannot be in the current year or future.</div>
            <div *ngIf="(this.submitted || formControls.dobInput.touched) && formControls.dobInput.touched && formControls.dobInput.errors.dobIsBeforeMinDate">
              Date of Birth cannot be before {{ getMinDateFormatted() }}.</div>
            <div *ngIf="(this.submitted || formControls.dobInput.touched) && formControls.dobInput.touched && formControls.dobInput.errors?.ngbDate?.invalid">
              Date of Birth should be a valid value in the following format: MM/DD/YYYY.</div>
          </div>
        </div>
        <small id="dobHelp" class="form-text text-muted">Please enter your Date of Birth in the following format: MM/DD/YYYY</small>

        <hr/>

        <div class="form-group form-label-group">
          <input id="emailInput" formControlName="emailInput" class="form-control" placeholder="Email Address"
                 [ngClass]="{ 'is-invalid': formControls.emailInput.touched && formControls.emailInput.errors }">
          <label for="emailInput">Email Address</label>
          <div *ngIf="formControls.emailInput.touched && formControls.emailInput.errors" class="invalid-feedback">
            <div *ngIf="(this.submitted || formControls.emailInput.touched) && formControls.emailInput.errors.required">Email Address is required.</div>
            <div *ngIf="(this.submitted || formControls.emailInput.touched) && formControls.emailInput.errors.email">Email Address is invalid.</div>
          </div>
        </div>
        <div class="form-group form-label-group">
          <input id="confirmEmailInput" formControlName="confirmEmailInput" class="form-control"
                 placeholder="Confirm Email Address" onpaste="return false;"
                 [ngClass]="{ 'is-invalid': formControls.confirmEmailInput.touched &&
                 (formControls.confirmEmailInput.errors || regForm.errors?.emailsAreNotEqual) }">
          <label for="confirmEmailInput">Confirm Email Address</label>
          <div *ngIf="formControls.confirmEmailInput.touched && (formControls.confirmEmailInput.errors || regForm.errors?.emailsAreNotEqual)"
               class="invalid-feedback">
            <div *ngIf="(this.submitted || formControls.confirmEmailInput.touched) && formControls.confirmEmailInput.errors?.required">Please, confirm email address.</div>
            <div *ngIf="(this.submitted || formControls.confirmEmailInput.touched) && !formControls.confirmEmailInput.errors?.required && regForm.errors?.emailsAreNotEqual">
              Confirm Email Address should match with the above field.</div>
          </div>
        </div>
        <div class="form-group form-label-group">
          <input id="phoneNumberInput" formControlName="phoneNumberInput" class="form-control" aria-describedby="phoneNumberHelp"
                 placeholder="Phone Number" [ngClass]="{ 'is-invalid': formControls.phoneNumberInput.touched && formControls.phoneNumberInput.errors }"
                 mask="(000) 000-0000">
          <label for="phoneNumberInput">Phone Number</label>
          <div *ngIf="formControls.phoneNumberInput.touched && formControls.phoneNumberInput.errors" class="invalid-feedback">
            <div *ngIf="(this.submitted || formControls.phoneNumberInput.touched) && formControls.phoneNumberInput.errors.required">Phone Number is required.</div>
            <div *ngIf="(this.submitted || formControls.phoneNumberInput.touched) && formControls.phoneNumberInput.errors.pattern">Phone Number is invalid. Please enter your 10-digit phone number.</div>
          </div>
          <small id="phoneNumberHelp" class="form-text text-muted">If you would like to use SMS in the event you need
            to reset your password, please enter your 10-digit US phone number. The phone number should also be
            verified after login. You will not receive marketing messages from us via SMS.</small>
        </div>
      </div>

      <hr class="mb-4">

      <app-terms-of-use #child (termsOfUseErrorEvent)="showTermsOfUseErrorMessage($event)"></app-terms-of-use>

      <div class="row pb-3">
        <div class="col-12 d-flex">
          <button type="submit" form="registrationForm" id="createAccountButton" [disabled]="!child.checkboxFlag"
                  class="btn rounded-pill bg-secondary text-white ml-auto px-4 py-2">
            <span class="font-weight-bold">Create My Account</span>
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-12 d-flex">
          <span class="ml-auto">Already have an account?<a href="#responsive-font-sizes"> Sign In</a></span>
        </div>
      </div>
    </form>

  </div>
</div>
